var _a;
import ouiBase from '@goldwasserexchange/oui';
import * as React from 'react';
import { useHookstate } from '@hookstate/core';
import { AccountType } from '../../types';
import { useLingui } from '@lingui/react';
export var labels = (_a = {},
    _a[AccountType.RTO] = {
        ID: AccountType.RTO,
        label: function (i18n) { return i18n._('Gold'); },
    },
    _a[AccountType.CONSEIL] = {
        ID: AccountType.CONSEIL,
        label: function (i18n) { return i18n._('Premium'); },
    },
    _a[AccountType.GESTION] = {
        ID: AccountType.GESTION,
        label: function (i18n) { return i18n._('Global+'); },
    },
    _a);
export var useLabel = function (accountType) {
    var i18n = useLingui().i18n;
    if (!accountType) {
        return '';
    }
    var translated = labels[accountType].label(i18n);
    return translated;
};
export var Label = function (props) {
    var accountType = props.accountType;
    var translated = useLabel(accountType);
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return React.createElement(React.Fragment, null, translated);
};
export var LabelOnPrimaryDimension = function () {
    var accountType = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
    return (React.createElement(Label, { accountType: accountType }));
};
export var LabelOnFieldPath = function () {
    var valueState = ouiBase.Form.useFormData();
    var accountType = useHookstate(valueState.onboarding.selectedService).get();
    return React.createElement(Label, { accountType: accountType });
};
